import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Button } from 'react-bootstrap';
import ModuleHeader from '../../components/ModuleHeader';
import { orderUploadOperations } from "./state";
import TableTemplate from '../../components/TableTemplate';
import { ORDER, ORDER_UPLOAD } from '../BPOrder/routes';
import $ from "jquery";
import { CSV_INVALID, CSV_2MB, INCORRECT_FILE, ERROR_UPLOAD} from "../../../utils/messages"
import view from '../../../includes/img/viewdetails.svg';

class OrderUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        this.props.fetchDefault({ riyoKigyoId: this.props.riyoKigyoId })
    }

    orderUploadDetails = (data) => {
        this.props.history.push({
            pathname: ORDER_UPLOAD + "/" + data.uploadNo,
            state: { record: data }
        });
    }

    orderUpload = (e) => {
        if (this.state.uploadFile) {
            this.props.upload(this.state.uploadFile, this.props.userCd, this.props.riyoKigyoId)
                .then((result) => {
                    result ? this.props.fetchDefault({ riyoKigyoId: this.props.riyoKigyoId })
                        .then(() => {
                            this.orderUploadDetails(result)
                        }) : this.setState({  error: CSV_INVALID })
                }).catch(()=>{ this.setState({  error: ERROR_UPLOAD })})
        }
    }

    handleFileChange = (e) => {
        let file = e.target.files[0]
        if( file.size > 2000000) {
            this.setState({ error: CSV_2MB })
        }else if(".csv" !==file.name.substring(file.name.lastIndexOf('.')) ){
            this.setState({ error: INCORRECT_FILE })
        }else{
            this.setState({ [e.target.name]: file, error: null})
        }
        
    }

    buttons = () => {
        return (
            <div >
                <br />
                 <Button
                        className="button-filter list-button"
                        onClick={() => this.props.history.push(ORDER)}
                    >
                        戻る
                </Button>
                <span className="pull-right ">
                    <span className="extra text-danger">{this.state.error}</span>
                    <span className="fileName">{this.state.uploadFile && this.state.uploadFile.name}</span>
                    <input
                        type="file"
                        accept=".csv"
                        id="uploadFile"
                        name="uploadFile"
                        className="hidden"
                        onChange={this.handleFileChange} />

                    <Button
                        className="button-filter list-button"
                        onClick={() => $('#uploadFile').click()}
                        id="uploadFileBtn"
                    >
                        選択
                    </Button>
                    <Button
                        className="button-filter list-button"
                        onClick={this.orderUpload}
                        disabled={!this.state.uploadFile}
                    >
                        アップロード
                </Button>
                    <Button
                        className="button-filter"
                        onClick={this.props.download}
                    >
                        フォーマットダウンロード
                </Button>
                </span>
               
            </div>
        )
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <ModuleHeader title={"受注データアップロード履歴"} />
                    <TableTemplate
                        {...this.props}
                        rowButtons={[
                            {
                                onClick: this.orderUploadDetails,
                                img: view,
                                bsStyle: "link"
                            }
                        ]}
                    />
                    {this.buttons()}

                  
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        riyoKigyoId: state.auth.credentials.riyo_kigyo_id,
        userCd: state.auth.credentials.user_cd,
        isAuthenticated: state.auth.isAuthenticated,
        tableHeader: state.orderUpload.tableHeader,
        tableList: state.orderUpload.list,
        tableColumns: state.orderUpload.tableColumns,
    }
};

const mapDispatchToProps = {
    fetchDefault: orderUploadOperations.fetchDefault,
    download: orderUploadOperations.downloadFile,
    upload: orderUploadOperations.uploadFile
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderUpload);